<template>
    <div class="icon_container">
        <i 
        v-if="show_filter_list"
        class="fa-solid fa-gear fa-lg" style="color: #ffffff;" @click="list_OnClick"></i>
        <div class="table_list_full_container" v-if="show_filter_list">
            <div class="filter_entry" v-for="(value, key) in filter_data" :key="key">
                <div class="filter_text">
                    {{ key }}
                </div>

                <div class="filter_check" @click="check_OnClick(key, value)">
                    <i v-if="value" class="fa-regular fa-square-check"></i>
                    <i v-else class="fa-regular fa-square"></i>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
    import check from '@/assets/filter_checked.svg'
    import uncheck from '@/assets/filter_unchecked.svg'

    export default {
        name: 'AppFilterList',
        props: {
            filter_data: {
                type: Object,
                default: () => ({
                    filter1: true,
                    filter2: true,
                    filter3: true,
                })
            },
            
        },
        data() {
            return {
                show_filter_list: false,
                filter_check: check,
                filter_uncheck: uncheck
            };
        },
        emits: ['update-filter'],
        methods: {
            list_OnClick() {
                this.show_filter_list = !this.show_filter_list;
               
            },
            check_OnClick(property, value) {
                console.log("check clicked")
                console.log(property);
               
                this.$emit('update-filter', { property, value: !value });
            },
        },
    };
</script>



<style scoped>
    .icon_container {
        position: relative;
        display: inline-block;
    }

    i {
        justify-self: center;
        align-self: center;
        position: relative;

    }

    .table_list_full_container {
        font-size: 12px;
        position: absolute;
        top: calc(100% + 0.7rem); 
        left: calc(100% - 4.3rem);
        background-color: #4D4D6C;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0.5rem ;
        z-index: 999; 
        color: white;
        font-weight: 500;
    }

    .filter_entry {
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        /* gap: 0.5rem; */
    }

   
    .filter_text {
        white-space: nowrap;
        width: 100%;
    }
    
    .filter_check{
        text-align: right;
        width: 100%;
    }
</style>